import { TimetableData } from '@/types/timetable'
import { API_URL } from '@/config/constants'

// Helper function to format schedule data to TimetableEntryDto format
// interface TimetableEntry {
//   id: string
//   className: string
//   subject: string
//   day: string
//   timeSlot: string
//   time?: string
//   teacherId: string
//   teacherID?: string
//   teacher?: string
//   classroomId: string
//   salle?: string
//   group1?: any
//   group2?: any
// }
// Helper function to format schedule data to entries format
// const formatScheduleDataToEntries = (data: TimetableData): TimetableEntry[] => {
//   const entries: TimetableEntry[] = []

//   // Convert scheduleData to entries format
//   if (data.scheduleData && Array.isArray(data.scheduleData)) {
//     data.scheduleData.forEach((classData) => {
//       const className = classData.class

//       // Process each day
//       Object.keys(classData).forEach((day) => {
//         // Skip the class property
//         if (day === 'class') return

//         // Process each lesson in the day
//         if (Array.isArray(classData[day])) {
//           classData[day].forEach((lesson) => {
//             if (lesson && lesson.subject) {
//               // Create a complete entry with all required fields
//               entries.push({
//                 id:
//                   lesson.id ||
//                   `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
//                 className: className,
//                 subject: lesson.subject,
//                 day: day,
//                 timeSlot: lesson.timeSlot || lesson.time,
//                 time: lesson.timeSlot || lesson.time,
//                 teacherId: lesson.teacherId || lesson.teacherID || '',
//                 teacherID: lesson.teacherId || lesson.teacherID || '',
//                 teacher:
//                   lesson.teacher ||
//                   `Teacher ${lesson.teacherId || lesson.teacherID || ''}`,
//                 classroomId: lesson.classroomId || lesson.salle || '',
//                 salle: lesson.classroomId || lesson.salle || '',
//                 group1: lesson.group1,
//                 group2: lesson.group2,
//               })
//             }
//           })
//         }
//       })
//     })
//   }

//   return entries
// }

/**
 * Saves the timetable data to the server
 * @param data - The timetable data to save
 * @param setInjectedData - Optional state setter for updating the injected data
 * @param unscheduledSubjects - Optional array of unscheduled subjects
 * @returns Promise that resolves when the save is complete
 */
export const saveTimetableToServer = async (
  data: TimetableData,
  setInjectedData?: (data: any) => void
): Promise<{ success: boolean; message: string; data?: any }> => {
  try {
 // console.logSaving timetable data to server:', data)

    // Fetch the original input data from the server if it's not in the current data
    if (!data.inputData) {
      try {
     // console.logFetching original input data from server...')
        const inputDataResponse = await fetch(
          `${API_URL}/timetable/etablissement`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          }
        )

        if (inputDataResponse.ok) {
          const serverData = await inputDataResponse.json()
          if (serverData.inputData) {
         // console.logSuccessfully fetched input data from server')
            data.inputData = serverData.inputData
          } else {
            console.warn('No input data found on server')
          }
        } else {
          console.warn(
            'Failed to fetch input data from server:',
            inputDataResponse.status
          )
        }
      } catch (error) {
        // console.error('Error fetching input data:', error)
      }
    }

    // Check for existing timetable
    let timetableId: string | null = null
    const storedTimetableId =
      typeof window !== 'undefined'
        ? localStorage.getItem('lastSavedTimetableId')
        : null

    if (storedTimetableId) {
   // console.logUsing stored timetable ID:', storedTimetableId)
      timetableId = storedTimetableId
    } else {
      try {
        const getResponse = await fetch(`${API_URL}/timetable/etablissement`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        })

        if (getResponse.ok) {
          const currentTimetable = await getResponse.json()
          timetableId = currentTimetable.id
       // console.logFound existing timetable with ID:', timetableId)

          if (timetableId && typeof window !== 'undefined') {
            localStorage.setItem('lastSavedTimetableId', timetableId)
          }
        } else {
          console.warn(
            'Could not find existing timetable, will create a new one'
          )
        }
      } catch (error) {
        // console.error('Error fetching current timetable:', error)
      }
    }

    // Format entries for the server
    // const entries = formatScheduleDataToEntries(data)
 // console.logFormatted entries for server:', entries)

    // Prepare the server data
    const serverData: any = {
      name: 'Generated Timetable',
      data: {
        scheduleData: data.scheduleData || [],
      },
      inputData: data.inputData || {
        timeSlots: {},
        salles: [],
        classes: [],
        teachers: [],
      },
      description: 'Generated Timetable',
      academicYear: `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`,
      isActive: true,
    }

    // Determine the appropriate endpoint and method
    let url = `${API_URL}/timetable`
    let method = 'POST'

    // Use PATCH if we have a timetable ID
    if (timetableId) {
      url = `${API_URL}/timetable/${timetableId}`
      method = 'PATCH'
      // console.log(
      //   'Using PATCH to update existing timetable with ID:',
      //   timetableId
      // )
    } else {
      // Try to get the existing timetable ID if we don't have one
      try {
        const checkResponse = await fetch(
          `${API_URL}/timetable/etablissement`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          }
        )

        if (checkResponse.ok) {
          const existingTimetable = await checkResponse.json()
          if (existingTimetable?.id) {
            url = `${API_URL}/timetable/${existingTimetable.id}`
            method = 'PATCH'
            // console.log(
            //   'Found existing timetable, using PATCH with ID:',
            //   existingTimetable.id
            // )
          } else {
            method = 'POST'
            // console.log(
            //   'No existing timetable found, using POST to create a new one'
            // )
          }
        }
      } catch (error) {
      //   console.log(
      //     'Error checking for existing timetable, using POST as fallback'
      //   )
      }
    }

    // Handle input data for new timetables
    if (method === 'POST') {
      if (data.inputData) {
        serverData.data.data = data.inputData
        serverData.inputData = data.inputData
      } else {
        // Generate input data from schedule data if not provided
        const defaultInputData: {
          timeSlots: Record<string, any>
          salles: any[]
          classes: { className: string; subjects: any[] }[]
          teachers: any[]
        } = {
          timeSlots: {},
          salles: [],
          classes: [],
          teachers: [],
        }

        // Populate default input data from schedule data
        if (data.scheduleData?.length) {
          // Extract classes, teachers, rooms, etc.
          // This is a simplified version - you'll need to implement the actual extraction
          // based on your data structure
          data.scheduleData.forEach((classData) => {
            if (classData.class) {
              defaultInputData.classes.push({
                className: classData.class,
                subjects: [],
              })
            }
          })
        }

        serverData.inputData = defaultInputData
        serverData.data.data = defaultInputData
      }
    }

    // Prepare the request body
    let requestBody = { ...serverData }

    // Remove name for PATCH requests if not allowed
    if (method === 'PATCH' && requestBody.name) {
      const { name, ...rest } = requestBody
      requestBody = rest
    }

    // Ensure required fields exist
    if (!requestBody.data?.scheduleData) {
      requestBody.data = {
        ...requestBody.data,
        scheduleData: data.scheduleData || [],
      }
    }

    // Make the API request
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(requestBody),
    })

    const responseText = await response.text()
    let responseData

    try {
      responseData = JSON.parse(responseText)
    } catch (e) {
      responseData = { message: responseText }
    }

    if (response.ok) {
      // Store the timetable ID for future use
      if (responseData.id && typeof window !== 'undefined') {
        localStorage.setItem('lastSavedTimetableId', responseData.id)
      }

      // Update the injected data if the setter is provided
      if (setInjectedData && responseData.data?.scheduleData) {
        const savedData = {
          ...responseData,
          scheduleData: responseData.data.scheduleData,
          inputData: responseData.inputData,
        }
        setInjectedData(savedData)
      }

      return {
        success: true,
        message: 'Timetable saved successfully',
        data: responseData,
      }
    } else {
      // console.error('Failed to save timetable:', {
      //   status: response.status,
      //   statusText: response.statusText,
      //   error: responseData,
      // })

      throw new Error(
        responseData.message ||
          `Failed to save timetable: ${response.status} ${response.statusText}`
      )
    }
  } catch (error) {
    // console.error('Error saving timetable:', error)
    throw error
  }
}
